import { HttpProvider } from "../http/http.provider";
import { IAppConfig } from "../http/types/IApplicationConfig";

import { addProvider, IProviderDescriptor, ServiceEndpointConstants } from "../ServiceUtil";
import { Observable } from "rxjs";
import { share, map } from "rxjs/operators";


import { createFormData } from "../util/utilities";
import { IHttpRequestConfig } from "../http";
import
{
    IElectronicCheck,
    INewEelectronicCheck,
    INewElectronicCheckComment,
    IManualCheck,
    INewManualCheck,
    INewManualCheckComment,

    INewBankDeposit,
    IBankDeposit,
    INewBankDepositCheck,
    INewEmpPayrollRecord,
    IEmpPayrollRecord,
    INewEmpPayrollRecordDetail,
    IValidatePayrolLRecord,
    IBankDepositResponse
} from "./accounting.interface";

/**
 * 
 */

export class AccountingDelegate
{
    constructor(private SERVICE_CONFIG: IAppConfig, private http: HttpProvider)
    {
    }

    public getAllElectronicChecks(orgId: string, year: number): Observable<IElectronicCheck[]>
    {
        const config: IHttpRequestConfig = {
            params:
            {
                orgId: orgId,
                year: year
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.ACCOUTING.GET_ELECTRONIC_CHEKS, null, config).pipe(
            map((response: any) =>
            {
                return this.normalizeElectronicChecks(response.data.electronicChecks);

            }),
            share());
    }


    public createNewElectronicCheck(newElectronicCheck: INewEelectronicCheck): Observable<any>
    {
        const formdata = createFormData(newElectronicCheck);

        return this.http.post(ServiceEndpointConstants.endpoints.ACCOUTING.CREATE_ELECTRONIC_CHECK, formdata).pipe(
            map((response: any) =>
            {
                return this.normalizeElectronicChecks(response.data.electronicChecks);

            }),
            share());

    }

    public createNewElectronicCheckComment(newElectronicCheckComment: INewElectronicCheckComment): Observable<any>
    {
        // const formdata = createFormData(newElectronicCheck);

        return this.http.post(ServiceEndpointConstants.endpoints.ACCOUTING.CREATE_ELECTRONIC_CHECK_COMMENT, newElectronicCheckComment).pipe(
            map((response: any) =>
            {
                return this.normalizeElectronicChecks(response.data.electronicChecks);

            }),
            share());

    }

    public UpdateElectronicCheck(newElectronicCheck: INewEelectronicCheck): Observable<any>
    {
        const formdata = createFormData(newElectronicCheck);

        return this.http.post(ServiceEndpointConstants.endpoints.ACCOUTING.UPDATE_ELECTRONIC_CHECK, formdata).pipe(
            map((response: any) =>
            {
                return this.normalizeElectronicChecks(response.data.electronicChecks);
            }),
            share());
    }

    private normalizeElectronicChecks(electronicChecks: any): IElectronicCheck[]
    {
        return electronicChecks.map(electronicCheck =>
        {
            electronicCheck.electronicCheckDocuments = electronicCheck.electronicCheckDocuments.map(document =>
            {
                document.configurationValue = document.configuration ? document.configuration.configurationValue : "";
                return document;
            });
            return electronicCheck as IElectronicCheck;
        });
    }


    public getAllManualChecks(orgId: string, year: number): Observable<IManualCheck[]>
    {
        const config: IHttpRequestConfig =
        {
            params:
            {
                orgId: orgId,
                year: year
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.ACCOUTING.GET_MANUAL_CHEKS, null, config).pipe(
            map((response: any) =>
            {
                return this.normalizeManualChecks(response.data.manualChecks);

            }),
            share());
    }


    public createNewManualCheck(newManualCheck: INewManualCheck): Observable<any>
    {
        const formdata = createFormData(newManualCheck);

        return this.http.post(ServiceEndpointConstants.endpoints.ACCOUTING.CREATE_MANUAL_CHECK, formdata).pipe(
            map((response: any) =>
            {
                return this.normalizeManualChecks(response.data.manualChecks);

            }),
            share());

    }

    public createNewManualCheckComment(newManualCheckComment: INewManualCheckComment): Observable<any>
    {
        // const formdata = createFormData(newMANUALCheck);

        return this.http.post(ServiceEndpointConstants.endpoints.ACCOUTING.CREATE_MANUAL_CHECK_COMMENT, newManualCheckComment).pipe(
            map((response: any) =>
            {
                return this.normalizeManualChecks(response.data.manualChecks);

            }),
            share());

    }

    public UpdateManualCheck(newManualCheck: INewManualCheck): Observable<any>
    {
        const formdata = createFormData(newManualCheck);

        return this.http.post(ServiceEndpointConstants.endpoints.ACCOUTING.UPDATE_MANUAL_CHECK, formdata).pipe(
            map((response: any) =>
            {
                return this.normalizeManualChecks(response.data.manualChecks);
            }),
            share());
    }

    public getAllBankDeposits(orgId: string): Observable<IBankDeposit[]>
    {
        const config: IHttpRequestConfig = {
            params:
            {
                orgId: orgId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.ACCOUTING.GET_BANK_DEPOSITS, null, config).pipe(
            map((response: any) =>
            {
                return this.normalizeBankDeposits(response.data.bankDeposits);

            }),
            share());
    }

    public createNewBankDeposit(newBankDeposit: INewBankDeposit): Observable<IBankDepositResponse>
    {
        const formdata = createFormData(newBankDeposit);

        return this.http.post(ServiceEndpointConstants.endpoints.ACCOUTING.CREATE_BANK_DEPOSIT, formdata).pipe(
            map((response: any) =>
            {
                return {
                    bankDeposits: this.normalizeBankDeposits(response.data.bankDeposits),
                    bankDepositId: response.data.bankDepositId
                };

            }),
            share());

    }

    public updateBankDeposit(newBankDeposit: INewBankDeposit): Observable<any>
    {
        const formdata = createFormData(newBankDeposit);

        return this.http.post(ServiceEndpointConstants.endpoints.ACCOUTING.UPDATE_BANK_DEPOSIT, formdata).pipe(
            map((response: any) =>
            {
                return {
                    bankDeposits: this.normalizeBankDeposits(response.data.bankDeposits),
                    bankDepositId: response.data.bankDepositId
                };
            }),
            share());

    }

    public createNewBankDepositCheck(newBankDeposit: INewBankDepositCheck): Observable<any>
    {
        const formdata = createFormData(newBankDeposit);

        return this.http.post(ServiceEndpointConstants.endpoints.ACCOUTING.CREATE_BANK_DEPOSIT_CHECK, formdata).pipe(
            map((response: any) =>
            {
                return this.normalizeBankDeposits(response.data.bankDeposits);

            }),
            share());

    }

    public updateBankDepositCheck(newBankDeposit: INewBankDepositCheck): Observable<any>
    {
        const formdata = createFormData(newBankDeposit);

        return this.http.post(ServiceEndpointConstants.endpoints.ACCOUTING.UPDATE_BANK_DEPOSIT_CHECK, formdata).pipe(
            map((response: any) =>
            {
                return this.normalizeBankDeposits(response.data.bankDeposits);

            }),
            share());

    }


    public getAllEmployeePayrollRecords(orgId: string): Observable<any>
    {
        const config: IHttpRequestConfig = {
            params: {
                OrgId: orgId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.PAYROLL.GET_EMPLOYEE_PAYROLL_RECORD, null, config).pipe(
            map((response: any) =>
            {
                return this.normalizePayrollRecords(response.data.employeePayrollRecord);

            }),
            share());
    }

    public createNewEmployeePayrollRecord(neewPayrollRecord: INewEmpPayrollRecord): Observable<any>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.PAYROLL.CREATE_EMPLOYEE_PAYROLL_RECORD, neewPayrollRecord).pipe(
            map((response: any) =>
            {
                return this.normalizePayrollRecords(response.data.employeePayrollRecord);

            }),
            share());
    }


    public validatePayrolLRecord(neewPayrollRecord: IValidatePayrolLRecord): Observable<any>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.PAYROLL.RE_VALIDATE_PAYROLL_RECORD, neewPayrollRecord).pipe(
            map((response: any) =>
            {
                return this.normalizePayrollRecords(response.data.employeePayrollRecord);

            }),
            share());
    }

    public loadPayrolLRecords(neewPayrollRecord: IValidatePayrolLRecord): Observable<any>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.PAYROLL.LOAD_PAYROLL_RECORD, neewPayrollRecord).pipe(
            map((response: any) =>
            {
                return this.normalizePayrollRecords(response.data.employeePayrollRecord);

            }),
            share());
    }


    public processEmployeePaystubs(orgId: string, payrollRecordId: string, userName: string): Observable<any>
    {

        return this.http.post(ServiceEndpointConstants.endpoints.PAYROLL.PROCESS_EMPLOYEE_PAYSTUBS, {
            OrgId: orgId,
            PayrollRecordId: payrollRecordId,
            UserName: userName
        }).pipe(share());
    }

    public createNewEmployeePayrollRecordDetail(neewPayrollRecord: INewEmpPayrollRecordDetail): Observable<any>
    {
        const formdata = createFormData(neewPayrollRecord);

        return this.http.post(ServiceEndpointConstants.endpoints.PAYROLL.CREATE_EMPLOYEE_PAYROLL_RECORD_DETAIL, formdata).pipe(
            map((response: any) =>
            {
                return this.normalizePayrollRecords(response.data.employeePayrollRecord);

            }),
            share());
    }

    private normalizeManualChecks(manualChecks: any): IManualCheck[]
    {
        return manualChecks.map(manualCheck =>
        {
            manualCheck.electronicCheckDocuments = manualCheck.electronicCheckDocuments.map(document =>
            {
                document.configurationValue = document.configuration ? document.configuration.configurationValue : "";
                return document;
            });
            return manualCheck as IManualCheck;
        });
    }

    private normalizeBankDeposits(bankDeposits: any): IBankDeposit[]
    {
        return bankDeposits.map(bankDeposit =>
        {
            /*      electronicCheck.electronicCheckDocuments = electronicCheck.electronicCheckDocuments.map(document => {
                      document.configurationValue = document.configuration ? document.configuration.configurationValue : "";
                      return document;
                  });*/
            return bankDeposit as IBankDeposit;
        });
    }

    private normalizePayrollRecords(payrollRecords: any): IEmpPayrollRecord[]
    {
        return payrollRecords.map(payrollRecord =>
        {
            return {
                employeePayrollRecordId: payrollRecord.employeePayrollRecordId,
                orgId: payrollRecord.orgId,
                payrollDate: payrollRecord.payrollDate,
                employeeId: payrollRecord.employeeId,
                employeePayrollRecordDetails: payrollRecord.employeePayrollRecordDetails,
                employeePayrollRecordDetailStages: payrollRecord.employeePayrollRecordDetailStages,
                employeePayrollRecordDetailStageValid: payrollRecord.employeePayrollRecordDetailStages ?
                    payrollRecord.employeePayrollRecordDetailStages.filter(x => x.status === "Good") : [],
                employeePayrollRecordDetailStageNotValid: payrollRecord.employeePayrollRecordDetailStages ?
                    payrollRecord.employeePayrollRecordDetailStages.filter(x => x.status !== "Good") : []
            } as IEmpPayrollRecord;
        });
    }
}